<app-side-panel
  [isOpen]="isOpen()"
  [isMinimized]="isMinimized()"
  [config]="sidePanelConfig()"
  [hasUnsavedChanges]="isDirty()"
  (panelClosed)="onClose()"
  (panelMinimized)="onMinimize()"
  (panelRestored)="onRestore()">

  <div class="contactar-utente">

    <!-- 1. Quick actions (20%) -->
    <section class="contactar-utente__section">
      <h4 class="contactar-utente__section-title">Ações rápidas</h4>
      <div class="contactar-utente__quick-row">
        <button type="button"
                class="contactar-utente__quick-btn"
                [class.contactar-utente__quick-btn--active]="showFollowUp()"
                (click)="toggleFollowUp()"
                title="Criar lembrete de follow-up MAT">
          <span class="material-symbols-outlined">event</span>
          <span>Criar lembrete</span>
        </button>
      </div>

      <!-- Inline follow-up form -->
      @if (showFollowUp()) {
        <div class="contactar-utente__followup">
          <div class="contactar-utente__form-row">
            <label class="contactar-utente__label" for="followup-subject">Assunto *</label>
            <input id="followup-subject"
                   type="text"
                   class="contactar-utente__input"
                   [value]="followUpSubject()"
                   (input)="onFollowUpSubjectInput($any($event.target).value)"
                   [disabled]="isFollowUpSaving()"
                   placeholder="Ex: Follow-up adesão terapêutica">
          </div>
          <div class="contactar-utente__form-row">
            <label class="contactar-utente__label">Data *</label>
            <app-datepicker
              [control]="followUpDateControl"
              [config]="{ placeholder: 'Selecione a data', required: true, showIcon: true, variant: 'outline' }">
            </app-datepicker>
          </div>
          @if (medications().length > 0) {
          <div class="contactar-utente__form-row">
            <label class="contactar-utente__label" for="followup-medication">Medicamento</label>
            <select id="followup-medication"
                    class="contactar-utente__select"
                    [value]="followUpMedicationId()"
                    (change)="followUpMedicationId.set($any($event.target).value)"
                    [disabled]="isFollowUpSaving()">
              <option value="">— Nenhum (geral) —</option>
              @for (m of medications(); track m.id) {
                <option [value]="m.id">{{ m.name }}</option>
              }
            </select>
          </div>
          }
          @if (teamMembers().length > 0) {
          <div class="contactar-utente__form-row">
            <label class="contactar-utente__label" for="followup-team-member">Registado por</label>
            <select id="followup-team-member"
                    class="contactar-utente__select"
                    [value]="followUpTeamMemberId()"
                    (change)="followUpTeamMemberId.set($any($event.target).value)"
                    [disabled]="isFollowUpSaving()">
              <option value="">— Selecione um membro —</option>
              @for (m of teamMembers(); track m.id) {
                <option [value]="m.id">{{ m.name }}</option>
              }
            </select>
          </div>
          }
          <div class="contactar-utente__form-row">
            <label class="contactar-utente__label" for="followup-notes">Notas</label>
            <textarea id="followup-notes"
                      class="contactar-utente__textarea"
                      rows="2"
                      [value]="followUpNotes()"
                      (input)="onFollowUpNotesInput($any($event.target).value)"
                      [disabled]="isFollowUpSaving()"
                      placeholder="Notas opcionais"></textarea>
          </div>
          @if (followUpError()) {
            <div class="contactar-utente__error" role="alert">{{ followUpError() }}</div>
          }
          <div class="contactar-utente__followup-actions">
            <button type="button"
                    class="contactar-utente__followup-btn contactar-utente__followup-btn--cancel"
                    (click)="toggleFollowUp()"
                    [disabled]="isFollowUpSaving()">
              Cancelar
            </button>
            <button type="button"
                    class="contactar-utente__followup-btn contactar-utente__followup-btn--save"
                    (click)="onFollowUpSave()"
                    [disabled]="!isFollowUpValid() || isFollowUpSaving()">
              {{ isFollowUpSaving() ? 'A criar...' : 'Criar lembrete' }}
            </button>
          </div>
        </div>
      }
    </section>

    <!-- 2. Guião de apoio — stepper (40%) -->
    <section class="contactar-utente__section">
      <h4 class="contactar-utente__section-title">Guião de apoio</h4>
      <div class="contactar-utente__stepper">
        @for (step of guiaoSteps; track step.key; let i = $index) {
          <div class="contactar-utente__step"
               [class.contactar-utente__step--active]="currentStepIndex() === i"
               [class.contactar-utente__step--completed]="i < currentStepIndex()"
               [class.contactar-utente__step--upcoming]="i > currentStepIndex()">

            <!-- Step indicator -->
            <div class="contactar-utente__step-indicator">
              <button type="button"
                      class="contactar-utente__step-circle"
                      (click)="goToStep(i)"
                      [attr.aria-label]="step.title">
                @if (i < currentStepIndex()) {
                  <span class="material-symbols-outlined">check</span>
                } @else {
                  <span>{{ i + 1 }}</span>
                }
              </button>
              @if (i < guiaoSteps.length - 1) {
                <div class="contactar-utente__step-line"
                     [class.contactar-utente__step-line--completed]="i < currentStepIndex()"></div>
              }
            </div>

            <!-- Step content (only for active step) -->
            <div class="contactar-utente__step-content">
              <button type="button"
                      class="contactar-utente__step-title-btn"
                      (click)="goToStep(i)">
                {{ step.title }}
              </button>
              @if (currentStepIndex() === i) {
                <ul class="contactar-utente__step-bullets">
                  @for (bullet of step.bullets; track bullet) {
                    <li>{{ bullet }}</li>
                  }
                </ul>
                <div class="contactar-utente__step-nav">
                  @if (i > 0) {
                    <button type="button"
                            class="contactar-utente__step-nav-btn"
                            (click)="goToStep(i - 1)">
                      <span class="material-symbols-outlined">arrow_back</span>
                      Anterior
                    </button>
                  }
                  @if (i < guiaoSteps.length - 1) {
                    <button type="button"
                            class="contactar-utente__step-nav-btn contactar-utente__step-nav-btn--next"
                            (click)="goToStep(i + 1)">
                      Seguinte
                      <span class="material-symbols-outlined">arrow_forward</span>
                    </button>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </section>

    <!-- 3. Registar interacção (40%) -->
    <section class="contactar-utente__section">
      <h4 class="contactar-utente__section-title">Registar interacção</h4>

      <div class="contactar-utente__form-row">
        <label class="contactar-utente__label" for="canal">Canal *</label>
        <select id="canal"
                class="contactar-utente__select"
                [value]="channel()"
                (change)="onChannelChange($any($event.target).value)"
                [disabled]="isSaving()">
          <option value="" disabled>— Selecione um canal —</option>
          @for (opt of channelOptions; track opt.value) {
            <option [value]="opt.value">{{ opt.label }}</option>
          }
        </select>
      </div>

      <div class="contactar-utente__form-row">
        <label class="contactar-utente__label" for="resultado">Resultado *</label>
        <select id="resultado"
                class="contactar-utente__select"
                [value]="outcome()"
                (change)="onOutcomeChange($any($event.target).value)"
                [disabled]="isSaving()">
          <option value="" disabled>— Selecione um resultado —</option>
          @for (opt of outcomeOptions; track opt.value) {
            <option [value]="opt.value">{{ opt.label }}</option>
          }
        </select>
      </div>

      <div class="contactar-utente__form-row">
        <label class="contactar-utente__label" for="team-member">Contacto efetuado por *</label>
        <select id="team-member"
                class="contactar-utente__select"
                [value]="selectedTeamMemberId()"
                (change)="selectedTeamMemberId.set($any($event.target).value)"
                [disabled]="isSaving()">
          <option value="" disabled>— Selecione um membro —</option>
          @for (m of teamMembers(); track m.id) {
            <option [value]="m.id">{{ m.name }}</option>
          }
        </select>
      </div>

      <div class="contactar-utente__form-row">
        <label class="contactar-utente__label" for="observacoes">Observações</label>
        <textarea id="observacoes"
                  class="contactar-utente__textarea"
                  rows="3"
                  maxlength="32000"
                  [value]="observations()"
                  (input)="onObservationsInput($any($event.target).value)"
                  [disabled]="isSaving()"
                  placeholder="Notas opcionais sobre a interacção"></textarea>
      </div>

      @if (serverError()) {
        <div class="contactar-utente__error" role="alert">
          {{ serverError() }}
        </div>
      }

      <div class="contactar-utente__actions">
        <app-button
          [config]="{ variant: 'warning', size: 'sm', text: 'Cancelar', disabled: isSaving() }"
          (clicked)="onCancelClick()">
        </app-button>
        <app-button
          [config]="{
            variant: 'animated',
            size: 'sm',
            text: isSaving() ? 'A guardar...' : 'Guardar',
            loading: isSaving(),
            disabled: !isValid() || isSaving()
          }"
          (clicked)="onSave()">
        </app-button>
      </div>
    </section>

  </div>
</app-side-panel>
